import React, { useEffect, useState } from "react";
import { homeClasses } from "./styles";
import { Box, Typography, CircularProgress } from "@mui/material";
import BgImg from "../../assets/images/bg.jpg";
import Topbar from "../../components/Topbar/Topbar";
import { SPColor } from "../../constants/color";
import MiniCard from "../../components/MiniCard/MiniCard";
import { CityOverviewType, School } from "../../types/record";
import CityOverview from "../../components/CircleProgress/CityOverview";
import Footer from "../../components/Footer/Footer";
import SchoolLeaderPage from "../../components/LeaderBoard/SchoolLeaderPage";
import GradeLeader from "../../components/LeaderBoard/GradeLeader";
import { SelectItem } from "../../types/global";

const gradeList: SelectItem[] = [
  { value: 100, label: `תחרות בין בתי הספר` },
  { value: 3, label: `תחרות בין הכיתות בשכבה ג'` },
  { value: 4, label: `תחרות בין הכיתות בשכבה ד'` },
  { value: 5, label: `תחרות בין הכיתות בשכבה ה'` },
  { value: 6, label: `תחרות בין הכיתות בשכבה ו'` },
  { value: 7, label: `תחרות בין הכיתות בשכבה ז'` },
  { value: 8, label: `תחרות בין הכיתות בשכבה ח'` },
  { value: 9, label: `תחרות בין הכיתות בשכבה ט'` },
  { value: 10, label: `תחרות בין הכיתות בשכבה י'` },
  { value: 11, label: `תחרות בין הכיתות בשכבה י"א` },
  { value: 12, label: `תחרות בין הכיתות בשכבה י"ב` },
];

const videos = [
  "7241093621217316097",
  "7241095130810174728",
  "7241834298779766017",
  //SP230623: replace stale video
  "7243712432806415617",
  // "7241110744576658689",

  // "https://www.tiktok.com/@speakingpal/video/7241093621217316097",
  // "https://www.tiktok.com/@speakingpal/video/7241095130810174728",
  // "https://www.tiktok.com/@speakingpal/video/7241834298779766017",
  // "https://www.tiktok.com/@speakingpal/video/7241110744576658689",
];

type WeekType = {
  tag: string;
  name: string;
};

export default function Home() {
  const classes = homeClasses;
  const [loading, setLoading] = useState<boolean>(false);
  const [schools, setSchools] = useState<School[]>([]);
  const [cityOverview, setCityOverview] = useState<CityOverviewType | null>(
    null
  );
  const [cityInfo, setCityInfo] = useState<any>(null);
  const params = new URLSearchParams(window.location.search);
  const city_id = params.get("city_id"); // returns string or null

  const fetchInitInfo = async (cityId: number) => {
    fetch(`${process.env.REACT_APP_API_URL}/api/init-info/${cityId}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.cityInfo?.error) {
          setLoading(false);
          alert(data.cityInfo?.message);
          return;
        }

        const schoolList = JSON.parse(data.school_list);
        setSchools(schoolList);
        setCityOverview(JSON.parse(data.city_overview));

        setCityInfo(JSON.parse(data.info));

        // setSchoolLeaderList(JSON.parse(data.school_leader_board));
        setLoading(false);
      });
  };

  useEffect(() => {
    if (city_id) {
      // fetchCityInfo(Number(city_id));
      fetchInitInfo(Number(city_id));
    }
  }, [city_id]);

  const [trigger, setTrigger] = useState<boolean>(false);

  const getDeviceConfig = (width: number) => {
    if (width < 320) {
      return "xs";
    } else if (width >= 320 && width < 720) {
      return "sm";
    } else if (width >= 720 && width < 1024) {
      return "md";
    } else if (width >= 1024) {
      return "lg";
    }
  };

  const [tiktokUrl, setTiktokUrl] = useState<string>("");

  const [page, setPage] = useState<string>("home");

  const [weeks, setWeeks] = useState<WeekType[]>([]);

  const handleScroll = () => {
    const position = window.pageYOffset;

    const basePosition =
      getDeviceConfig(window.innerWidth) === "sm" ? 125 : 170;
    if (position > basePosition) {
      setTrigger(true);
    } else {
      setTrigger(false);
    }
  };

  const getWeekList = () => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/week-list`)
      .then((response) => response.json())
      .then((res) => {
        setWeeks(res);
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);

    window.addEventListener("scroll", handleScroll, { passive: true });

    const generateRandom = () => {
      const maxNum = Date.now() % 4;
      return videos[maxNum];
    };

    setTiktokUrl(generateRandom());

    getWeekList();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const openSelectList = (type: string) => {
    console.log("type", type);
    setPage(type);
  };

  const handleClickCard = (type: string) => {
    if (type === "home") {
      setPage(type);
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: { md: "calc(100vh - 300px)", xs: "calc(100vh - 250px)" },
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  const MiniCardGroups = () => (
    <Box
      sx={{
        ...classes.cardList,
        marginTop: { md: "38.5px", xs: 1 },
        zIndex: 100,
      }}
    >
      <MiniCard
        bgColor={SPColor.ORANGE}
        onClick={() => openSelectList("school")}
        sx={{
          ...classes.miniCard,
          border:
            page === "school"
              ? "solid 3px " + SPColor.WHITE
              : "solid 1px " + SPColor.DARK_BLUE,
        }}
      >
        <Typography
          component={"h5"}
          variant="h5"
          color={SPColor.WHITE}
          sx={{ fontSize: { xs: "1.3rem", md: "1.5rem" } }}
          fontWeight={page === "school" ? "bold" : 400}
        >
          מבט בית ספרי
        </Typography>
      </MiniCard>
      <MiniCard
        bgColor={SPColor.GREEN}
        sx={{
          marginLeft: 2,
          ...classes.miniCard,
          border:
            page === "grade"
              ? "solid 3px " + SPColor.WHITE
              : "solid 1px " + SPColor.DARK_BLUE,
        }}
        onClick={() => openSelectList("grade")}
      >
        <Typography
          component={"h5"}
          variant="h5"
          color={SPColor.WHITE}
          sx={{ fontSize: { xs: "1.3rem", md: "1.5rem" } }}
          fontWeight={page === "grade" ? "bold" : 400}
        >
          תחרות עירונית
        </Typography>
      </MiniCard>
      <MiniCard
        bgColor={SPColor.LIGHT_BLUE}
        sx={{
          ...classes.miniCard,
          marginLeft: 2,
          border:
            page === "home"
              ? "solid 3px " + SPColor.WHITE
              : "solid 1px " + SPColor.DARK_BLUE,
        }}
        onClick={() => handleClickCard("home")}
      >
        <Typography
          component={"h5"}
          variant="h5"
          color={SPColor.WHITE}
          sx={{ fontSize: { xs: "1.3rem", md: "1.5rem" } }}
          fontWeight={page === "home" ? "bold" : 400}
        >
          מבט עירוני
        </Typography>
      </MiniCard>
    </Box>
  );

  return (
    <>
      <Box
        sx={{
          ...classes.banner,
          backgroundImage: `url(${cityInfo?.background_image})`,
          zIndex: 100,
        }}
        position={trigger ? "fixed" : "initial"}
        marginTop={{ md: trigger ? "-172px" : 0, xs: trigger ? "-128px" : 0 }}
        // marginTop={trigger ? "-172px !important" : "0"}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Topbar logo={cityInfo?.logo} />
        </div>
        <Box sx={classes.bannerBody}>
          <Box sx={{ marginTop: { md: "-30.5px", xs: 0 } }}>
            <Typography
              component={"h3"}
              variant="h3"
              color={SPColor.WHITE}
              sx={{ fontSize: { xs: "2rem", md: "3.5rem" } }}
            >
              {cityInfo?.title}
            </Typography>
            <Typography
              component={"h4"}
              variant="h4"
              color={SPColor.WHITE}
              sx={{ fontSize: { xs: "1.3rem", md: "1.8rem" } }}
            >
              {cityInfo?.subtitle}
            </Typography>
          </Box>
          {MiniCardGroups()}
        </Box>
      </Box>

      <Box marginTop={{ md: trigger ? "312px" : 2, xs: trigger ? "275px" : 2 }}>
        <Box
          minHeight={{ md: "calc(100vh - 451px)", xs: "calc(100vh - 411px)" }}
          sx={{
            maxWidth: { xl: "lg", ls: "sm" },
            margin: "auto",
            // paddingX: '2px',
          }}
          marginTop={trigger ? "362px" : "50px"}
        >
          {(!!!page || page === "home") && (
            <CityOverview
              cityOverview={cityOverview}
              tiktokUrl={tiktokUrl}
              homeIframeUrl={cityInfo?.home_content_url}
            />
          )}
          {page === "grade" && (
            <GradeLeader
              gradeList={gradeList}
              weeks={weeks}
              competitionIframeUrl={cityInfo?.competition_content_url}
              cityId={city_id}
              subject={cityInfo?.subject}
            />
          )}
          {page === "school" && (
            <SchoolLeaderPage
              schools={schools}
              weeks={weeks}
              cityId={city_id}
              subject={cityInfo?.subject}
            />
          )}
        </Box>
        <Footer />
      </Box>
    </>
  );
}
